const themeReducer = (theme = "light", action) => {
    switch (action.type) {
        case "SET_THEME":
            return action.payload;
        default:
            return theme;
    }
};

export default themeReducer;